import { database, ref, get } from "../FirebaseConfig";

/**
 * Charge toutes les données initiales nécessaires depuis Firebase
 * @param {string} userId - L'identifiant de l'utilisateur
 * @returns {Promise<{success: boolean, data: object, error: string|null}>}
 */
export const loadInitialData = async (userId) => {
  // Vérification du paramètre
  if (!userId) {
    return {
      success: false,
      data: {},
      error: "ID utilisateur requis"
    };
  }

  try {
    // Création des références aux différents nœuds de la base de données
    const userRef = ref(database, `vendeur/${userId}`);
    const channelsRef = ref(database, `channels/${userId}`);
    const productsRef = ref(database, `products/${userId}`);
    const aggregatorsRef = ref(database, `aggregators`);
    const userAggregatorsRef = ref(database, `userAggregatorKeys/${userId}`);
    const adminAggregatorsRef = ref(database, `userAggregatorKeys/604915269`); // ID admin fixe
    const configRef = ref(database, `config/subscription_durations`);
    const photosRef = ref(database, `photo`);
    
    // Récupération parallèle de toutes les données nécessaires
    const [
      userSnapshot,
      channelsSnapshot,
      productsSnapshot,
      aggregatorsSnapshot,
      userAggregatorsSnapshot,
      adminAggregatorsSnapshot,
      configSnapshot,
      photosSnapshot,
      abonnementsSnapshot
    ] = await Promise.all([
      get(userRef),
      get(channelsRef),
      get(productsRef),
      get(aggregatorsRef),
      get(userAggregatorsRef),
      get(adminAggregatorsRef),
      get(configRef),
      get(photosRef),
      get(ref(database, `abonnements`))
    ]);

    // Traitement des données
    const result = {
      success: true,
      data: {
        userData: userSnapshot.exists() ? userSnapshot.val() : null,
        userChannels: channelsSnapshot.exists() ? channelsSnapshot.val() : {},
        userProducts: productsSnapshot.exists() ? productsSnapshot.val() : [],
        allAggregators: aggregatorsSnapshot.exists() ? aggregatorsSnapshot.val() : null,
        userAggregators: userAggregatorsSnapshot.exists() ? userAggregatorsSnapshot.val() : null,
        adminAggregators: adminAggregatorsSnapshot.exists() ? adminAggregatorsSnapshot.val() : null,
        subscriptionConfig: configSnapshot.exists() ? configSnapshot.val() : null,
        photos: photosSnapshot.exists() ? photosSnapshot.val() : null,
        userSubscriptions: []
      },
      error: null
    };

    // Traitement des abonnements
    if (abonnementsSnapshot.exists()) {
      const allAbonnements = abonnementsSnapshot.val();
      Object.entries(allAbonnements).forEach(([key, abonnement]) => {
        if (abonnement.vendorId === userId) {
          result.data.userSubscriptions.push({
            id: key,
            ...abonnement
          });
        }
      });
    }

    return result;
  } catch (error) {
    console.error("Erreur lors du chargement des données initiales:", error);
    return {
      success: false,
      data: {},
      error: error.message || "Erreur lors du chargement des données"
    };
  }
};